import { lazy, Suspense } from "react";

// Critical sections loaded immediately (above the fold)
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import KeyBenefits from "@/components/KeyBenefits";
import ProblemSection from "@/components/ProblemSection";
import Footer from "@/components/Footer";

// Below-the-fold sections loaded lazily
const Features = lazy(() => import("@/components/Features"));
const ProofSection = lazy(() => import("@/components/ProofSection"));
const BenefitsSection = lazy(() => import("@/components/BenefitsSection"));
const TrustSection = lazy(() => import("@/components/TrustSection"));
const FinalProofSection = lazy(() => import("@/components/FinalProofSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const CTASection = lazy(() => import("@/components/CTASection"));

// Minimal loading component for smooth UX
const SectionLoading = () => (
  <div className="py-12 bg-background">
    <div className="container mx-auto px-6">
      <div className="max-w-4xl mx-auto">
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mx-auto"></div>
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mx-auto"></div>
          <div className="grid md:grid-cols-3 gap-4 mt-8">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-32 bg-gray-200 dark:bg-gray-700 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

const Index = () => {
  return (
    <div className="min-h-screen max-w-full overflow-x-hidden">
      {/* Critical above-the-fold sections */}
      <Header />
      <Hero />
      <KeyBenefits />
      <ProblemSection />
      
      {/* Lazy-loaded below-the-fold sections */}
      <Suspense fallback={<SectionLoading />}>
        <Features />
      </Suspense>
      
      <Suspense fallback={<SectionLoading />}>
        <ProofSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoading />}>
        <BenefitsSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoading />}>
        <TrustSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoading />}>
        <FinalProofSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoading />}>
        <FAQSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoading />}>
        <CTASection />
      </Suspense>
      
      <Footer />
    </div>
  );
};

export default Index;
